import { IAjaxConfig } from '../helpers';

export class EnumApiBusiness {
  /**
   * @dec 获取商机列表
   */
  readonly business_search: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/applet/queryList',
    method: 'post',
  };

  /**
   * @dec 获取商机报价单列表
   */
  readonly businessPriceQuotationList_search: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/t2/quotation/list',
    method: 'post',
  };

  /**
   * @dec 获取商机报价单审核列表
   */
  readonly businessPriceQuotationReviewList_search: IAjaxConfig = {
    url: '/api/bpportal/pcsd-bp-bo/portal/priceReview/queryPriceReviewList',
    method: 'post',
  };

  /**
   * @dec 获取绑定用户信息
   */
  readonly subscriptionOfUser: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/wx/subscriptionOfUser',
    method: 'get',
  };

  /**
   * @dec 订阅成功
   */
  readonly subscriptionOfAuthorization: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/wx/subscriptionOfAuthorization',
    method: 'get',
  };
  /**
   * @dec 返回授权登陆的地址
   */
  readonly getAuthorizationUrl: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/wx/getAuthorizationUrl',
    method: 'get',
  };
  /**
   * @dec 提交商机信息
   */
  readonly business_addOpportunity: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/applet/addOpportunity',
    loading: true,
    method: 'post',
  };
  /**
   * @dec 校验客户名称
   */
  readonly business_externalVerify: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/applet/externalVerify',
    method: 'get',
  };
  /**
   * @dec 新增产品
   */
  readonly business_saveProduct: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/applet/saveProduct',
    loading: true,
    method: 'post',
  };
  /**
   * @dec 删除产品
   */
  readonly business_deleteProduct: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/applet/deleteProduct',
    loading: true,
    method: 'get',
  };

  /**
   * @dec 获取编辑商机时产品列表信息
   */
  readonly business_busProductDetail: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/applet/busProductDetail',
    method: 'get',
  };

  /**
   * @des 获取智能报价单列表
   */
  readonly rapidQuotation_list: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/L1/quick/quotation/applet/list',
    method: 'post',
  };

  /**
   * @des 获取智能报价单详情
   */
  readonly rapidQuotation_details: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/L1/quick/quotation/applet/detail',
    method: 'get',
  };

  /**
   * @dec 获取智能报价产品列表信息
   */
  readonly rapidQuotation_productList: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/L1/quick/applet/productSearch',
    method: 'post',
  };

  /**
   * @description 获取智能报价商品分类
   */
  readonly rapidQuotation_productCategory: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/L1/quick/applet/queryProductClassify',
    method: 'get',
  };

  /**
   * @description L1智能报价分销商，产品组，以及分销商基本信息
   */
  readonly rapidQuotation_getDistributor: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/L1/quick/applet/queryDistribution',
    method: 'get',
  };

  /**
   * @dec 获取智能报价单个商品的阶梯价格
   */
  readonly rapidQuotation_productPrice: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/L1/quick/applet/productPrice',
    method: 'post',
  };

  /**
   * @description 智能报价单 新增/编辑收货地址
   */
  readonly rapidQuotation_addOrUpdateAddress: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/L1/quick/applet/addOrUpdateAddress',
    method: 'POST',
  };

  /**
   * @description 智能报价单 删除收货地址
   */
  readonly rapidQuotation_removeAddress: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/L1/quick/applet/deleteAddress',
    method: 'post',
  };

  /**
   * @description 智能报价单 收货地址查询
   */
  readonly rapidQuotation_addressList: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/L1/quick/applet/findAddressList',
    method: 'post',
  };

  /**
   * @description 智能报价单 收货地址详情查询
   */
  readonly rapidQuotation_addressDetails: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/L1/quick/applet/findAddressById',
    method: 'get',
  };

  /**
   * @description 智能报价单 创建
   */
  readonly rapidQuotation_submit: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/L1/quick/quotation/applet/add',
    method: 'post',
  };

  /**
   * @dec 获取码表 行业： INDUSTRY_CONFIG  公司规模：STAFF_SIZE_CONFIG
   */
  readonly business_GetDictionary: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/common/getDictionary',
    method: 'get',
  };

  /**
   * @dec 产品列表编辑单条信息
   */
  readonly business_updateProduct: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/applet/updateProduct',
    method: 'post',
  };

  /**
   * @dec 提交产品
   */
  readonly business_submit: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/applet/submit',
    loading: true,
    method: 'get',
  };

  /**
   * @dec 查询产品
   */
  readonly business_productSearch: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/applet/productSearch',
    loading: true,
    method: 'post',
  };

  /**
   * @dec 获取二维码
   */
  readonly business_subscriptionBusBoV2: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/wx/subscriptionBusBoV2',
    method: 'get',
  };

  /**
   * @dec 根据产品id查询产品信息/用来编辑自定义信息
   */
  readonly business_productDetail: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/applet/productDetail',
    method: 'get',
  };

  /**
   * @dec 根据busCode获取商机详情
   */
  readonly business_opportunityDetail: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/applet/opportunityDetail',
    method: 'get',
  };

  /**
   * @dec 根据busCode获取报价单详情
   */
  readonly business_reportDetail: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/applet/reportDetail',
    method: 'get',
  };

  /**
   * @dec sales商机报价单详情
   */
  readonly business_priceQuotationDetail: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/t2/quotation/detail',
    method: 'get',
  };

  /**
   * @dec 复制商机
   */
  readonly business_copyBus: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/applet/copyBus',
    method: 'get',
  };

  /**
   * @dec 报价单拒单
   */
  readonly business_refuseOrder: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/applet/refuseOrder',
    method: 'post',
  };

  /**
   * @dec 检查报价单有效期
   */
  readonly business_checkPriceSheet: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/applet/checkPriceSheet',
    method: 'get',
  };
  /**
   * @dec 转单信息
   */
  readonly business_priceSheetSplit: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/applet/priceSheetSplit',
    method: 'get',
  };
  /**
   * @dec 商机报价单转单信息
   */
  readonly business_priceQuotationSheetSplit: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/t2/quotation/priceSheetSplit',
    method: 'get',
  };
  /**
   * @dec 收货地址列表查询
   */
  readonly business_findAddressList: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/applet/findAddressList',
    method: 'post',
  };
  /**
   * @dec 收货地址详情查询
   */
  readonly business_findAddressById: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/applet/findAddressById',
    method: 'get',
  };
  /**
   * @dec 收货地址删除
   */
  readonly business_deleteAddress: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/applet/deleteAddress',
    method: 'post',
  };
  /**
   * @dec 收货地址新增
   */
  readonly business_addOrUpdateAddress: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/applet/addOrUpdateAddress',
    method: 'post',
  };
  /**
   * @dec 获取商机消息通知轮询
   */
  readonly business_busStateChange: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/applet/busStateChange',
    method: 'get',
    ignoreLoading: true,
    loading: false,
    timeout: 40000,
  };
  /**
   * @dec 立刻响应的商机消息通知
   */
  readonly business_realTimeBusStateChange: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/applet/realTimeBusStateChange',
    method: 'get',
    ignoreLoading: true,
  };
  /**
   * @dec 清空商机消息通知
   */
  readonly business_cleanStateChange: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/applet/cleanStateChange',
    method: 'get',
  };
  /**
   * @dec 已读商机消息通知
   * @method post
   * @params
   */
  readonly business_readStateChange: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/manage/readStateChange',
    method: 'post',
  };
  /**
   * @dec 添加产品分类列表
   */
  readonly business_queryProductClassify: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/applet/queryProductClassify',
    method: 'get',
  };
  /**
   * @dec 转单提交
   */
  readonly business_transferOrder: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/applet/transferOrder',
    method: 'post',
  };
  /**
   * @dec 报价单转单提交
   */
  readonly businessPriceQuotation_transferOrder: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/t2/quotation/transferOrder',
    method: 'post',
  };
  /**
   * @dec 订单详情（商机详情中）
   */
  readonly business_findOrderDetail: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/applet/findOrderDetail',
    method: 'post',
  };
  /**
   * @dec Bidding信息详情
   */
  readonly business_getBusBiddingDetail: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/manage/getBusBiddingDetail',
    method: 'get',
  };
  /**
   * @dec PC商机消息已经读
   */
  readonly businesspc_readStateChange: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/manage/readStateChange',
    method: 'get',
  };
  /**
   * @dec PC商机消息清空
   */
  readonly businesspc_cleanStateChange: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/manage/cleanStateChange',
    method: 'get',
  };
  /**
   * @dec  获取店面信息
   * @method get
   * @params
   */
  readonly business_getShopInfo: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/manage/getShopInfo',
    method: 'get',
  };

  /**
   * @dec  报价单转单页面拒绝转单
   * @method get
   * @params
   */
  readonly business_priceQuotation_refuse: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/t2/quotation/refuse',
    method: 'post',
  };

  /**
   * @dec  报价单转单页面获取店面信息
   * @method get
   * @params
   */
  readonly business_priceQuotation_getShopInfo: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/t2/quotation/getShopInfo',
    method: 'get',
  };

  /**
   * @dec 商机报价单详情页修改产品数量
   * @method get
   */
  readonly business_priceQuotation_updateProductNumber: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-bo/portal/t2/quotation/updateProductNumber',
    method: 'post',
  };

  /**
   * @dec 商机报价单审核详情页
   * @method get
   */
  readonly business_priceQuotationReview_detail: IAjaxConfig = {
    url: '/api/bpportal/pcsd-bp-bo/portal/priceReview/PriceReviewDetail',
    method: 'get',
  };

  /**
   * @dec 商机报价单审核页删除产品
   * @method get
   */
  readonly business_priceQuotationReview_deleteProduct: IAjaxConfig = {
    url: '/api/bpportal/pcsd-bp-bo/portal/priceReview/productDelete',
    method: 'get',
  };

  /**
   * @dec 商机报价单审核页获取产品列表
   * @method post
   */
  readonly business_priceQuotationReview_productList: IAjaxConfig = {
    url: '/api/bpportal/pcsd-bp-bo/portal/priceReview/productSearch',
    method: 'post',
  };

  /**
   * @dec 商机报价单审核页增加产品
   * @method post
   */
  readonly business_priceQuotationReview_productChange: IAjaxConfig = {
    url: '/api/bpportal/pcsd-bp-bo/portal/priceReview/productAdd',
    method: 'post',
  };

  /**
   * @dec 商机报价单审核页修改已选产品
   * @method post
   */
  readonly business_priceQuotationReview_replaceProduct: IAjaxConfig = {
    url: '/api/bpportal/pcsd-bp-bo/portal/priceReview/productReplace',
    method: 'post',
  };

  /**
   * @dec 商机报价单审核页修改已选产品
   * @method post
   */
  readonly business_priceQuotationReview_updateProduct: IAjaxConfig = {
    url: '/api/bpportal/pcsd-bp-bo/portal/priceReview/productUpdate',
    method: 'post',
  };

  /**
   * @dec 商机报价单审核页审核通过
   * @method post
   */
  readonly business_priceQuotationReview_approve: IAjaxConfig = {
    url: '/api/bpportal/pcsd-bp-bo/portal/priceReview/approve',
    method: 'post',
  };
}
